export const localDateString = (date) => {
  const new_date = new Date(date);

  return new_date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
